import React from "react";
import { useCamp } from "@/context/SettingsContext";

/** Schuine DEMO-stempel over afdrukken van een demo-camping. */
export default function DemoStamp() {
  const { camp } = useCamp();
  if (!camp?.demo_watermark) return null;
  return (
    <div className="pointer-events-none fixed inset-0 z-50 grid place-items-center" aria-hidden="true" data-testid="demo-stamp">
      <div className="-rotate-[38deg] text-center" style={{ color: "rgba(217,51,51,0.16)" }}>
        <p className="font-display font-extrabold leading-none" style={{ fontSize: "9rem" }}>DEMO</p>
        <p className="font-bold tracking-[0.3em] text-xl mt-2">GEEN GELDIGE FACTUUR</p>
      </div>
    </div>
  );
}
